<template>
  <div class="message">
    <div class="retreat" @click="retreat">
      <van-icon name="arrow-left" color="#fff" />
    </div>
    <div class="title">{{ $t('message.user.my_crea') }}</div>
    <div class="context">
      <div class="img_box">
        <div class="award_img">
          <viewer class="award_img" :images="Array.from(certslist)">
            <img :src="certslist.image" alt="" />
          </viewer>
        </div>
        <p>{{ certslist.activeName }}</p>
      </div>
      <div class="but_crea">
        <div class="download" @click="downloadfun(getDay(), certslist.certificate)">
          {{ $t('message.user.download') }}
        </div>
        <div @click="copy" class="share">{{ $t('message.user.share') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getByCertificateResultId } from '@/api/user.js'
import { Toast } from 'vant'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      certslist: {}
    }
  },
  //监听属性 类似于data概念
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    retreat() {
      // 返回上一级
      this.$router.go(-1)
    },
    async getByCertificateResultId() {
      const { data: res } = await getByCertificateResultId({ id: this.id })
      if (res.resultCode == 200) {
        this.certslist = res.data
      }
    },
    downloadfun(file_name, file_path) {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        Toast('请点击右上角使用浏览器打开')
      }
      var ajax = new XMLHttpRequest()
      ajax.open('GET', file_path, true)
      ajax.setRequestHeader('Cache-Control', 'no-cache')
      ajax.setRequestHeader('Access-Control-Allow-Origin', '*')
      ajax.responseType = 'blob'
      ajax.onload = (e) => {
        console.log(e)
        let res = e.target.response
        // let blob = new Blob([res],{type: "application/pdf;charset=UTF-8"}) // 这里的res为后端返回的流数据
        let blob = new Blob([res])
        let aLink = document.createElement('a')
        aLink.download = file_name + '.pdf' // 下载文件的名字
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
      }
      ajax.send()
    },
    getDay() {
      let time = new Date(),
        year = time.getFullYear(),
        month = time.getMonth() + 1,
        day = time.getDate(),
        timeStem = time.getTime()
      return `${year}/${month}/${day}/${timeStem}`
    },

    copy() {
      this.$copyText(window.location.href).then(
        () => {
          Toast.success(this.$t('message.user.copy_suc'))
        },
        () => {
          Toast.success(this.$t('message.user.copy_failed'))
        }
      )
    }
  },
  //生命周期 - 创建完成(可以访问当前this实例)
  created() {
    this.getByCertificateResultId()
  },
  //生命周期 - 挂载完成(可以访问DOM元素)
  mounted() {}
}
</script>
<style scoped lang="less">
* {
  margin: 0px;
  padding: 0px;
}

.message {
  width: 100%;
  //height: 100vh;
  overflow: auto;
  box-sizing: border-box;
  background-size: 100% 172px;
  background-image: url('../../../../static/image/user_bjt.png');
  background-repeat: no-repeat;
  position: relative;

  .retreat {
    position: absolute;
    top: 44px;
    left: 26px;
  }

  .title {
    text-align: center;
    font-size: 16px;
    color: #fff;
    margin-top: 43px;
  }

  .context {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: #fff;
    margin-top: 15px;
    border-radius: 30px 30px 0 0;
    padding: 27px 15px 0 25px;

    .img_box {
      margin: 0px 30px;

      p {
        padding: 20px 0px;
      }
    }

    .award_img {
      width: 250px;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .but_crea {
      margin: 0px 30px;

      width: 250px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        text-align: center;
        color: #3562ff;
        box-sizing: border-box;
        // width: 72px;
        padding: 0 15px;
        height: 32px;
        line-height: 32px;
        background: rgba(53, 98, 255, 0.08);
        border: 1px solid #3562ff;
        border-radius: 31px;
      }
    }
  }
}
</style>
